type DiscountTagProps = {
  discount: number;
};

/**
 * The DiscountTag component renders the discount tag of a wine package.
 * @param discount - The discount of the wine package.
 * @returns The DiscountTag component is returning JSX elements.
 */

export const DiscountTag = ({ discount }: DiscountTagProps) => {
  if (discount <= 0) return <></>;

  return <div className='absolute top-4 left-3 bg-[#C01010] text-[14px] rounded-sm font-semibold text-white min-[350px]:py-1 px-2'>{-discount.toFixed(0)}%</div>;
};
